let filters = document.querySelectorAll( '.m-filters a, .c-filters a' )
if( filters ) {
  const currentUrl = window.location.href
  for( const filter of filters ) {
    if( filter.href == currentUrl )
      filter.classList.add( 'active' )
  }

  if( window.location.search.length > 0 ) {
    const element = document.querySelector( '.m-breadcrumb' )
    if( element ) {
      const offset = window.scrollY + element.getBoundingClientRect().bottom - 100
      window.scroll( { top: offset, behavior: 'smooth' } )
    }
  }
}
